import { getBuildNumber, getVersionNumber } from "../utils/environment";

export const getBuildVersion = (): string =>
  `${getVersionNumber()}.${getBuildNumber()}`;

export const getDefaultHeaders = (
  token: string | undefined | null
): Record<string, string> => ({
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
  "X-Build-Version": getBuildVersion()
});
